import { CHAT_POLL_IDLE_MS, useChatMessages } from '@/api/hooks/useChatMessages'
import { AppTabBar } from '@/components/AppTabBar'
import ProtectedPage from '@/components/ProtectedPage'
import { colors } from '@/constants/colors'
import { Tabs } from 'expo-router'

export default function TabsLayout() {
	const chat = useChatMessages(CHAT_POLL_IDLE_MS)
	const unread = chat.isError || chat.isLoading ? 0 : chat.unreadCount

	return (
		<ProtectedPage>
			<Tabs
				tabBar={(props) => <AppTabBar {...props} />}
				screenOptions={{
					headerShown: false,
					tabBarPosition: 'top',
					sceneStyle: { backgroundColor: colors.ground },
					lazy: true,
				}}
			>
				<Tabs.Screen name="index" options={{ title: 'Home' }} />
				<Tabs.Screen name="care" options={{ title: 'Care' }} />
				<Tabs.Screen name="billing" options={{ title: 'Billing' }} />
				<Tabs.Screen
					name="chat"
					options={{ title: 'Chat', tabBarBadge: unread || undefined }}
				/>
				<Tabs.Screen name="profile" options={{ title: 'Account' }} />
			</Tabs>
		</ProtectedPage>
	)
}
